import { UAParser } from 'ua-parser-js';
// singleton export since the user agent doesn't need to be re-instantiated during the lifecyle of the app
export default new UAParser();
//# sourceMappingURL=user_agent_parser.js.map